<script>
export default {
  name: "ptMap",
  props: {
    style: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          height: '100%'
        }
      }
    },
    keyword: {
      type: String,
      default: ''
    },
    zoom: {
      type: Number,
      default: 13
    },

    searchOption: {
      type: Object,
      default: () => {
        return {
          city: '北京',
          citylimit: true
        }
      }
    }
  },
  data() {
    return {
      center: [],
      markers: [],
      searchText: '',
      city: '全国',
      zoomIndex: 15,
      map: {}
    }
  },
  mounted() {
    this.zoomIndex = this.zoom
  },
  methods: {
    init(initMap) {
      this.map = initMap
      if (this.keyword) {
        this.searchText = this.keyword
      }
      this.$nextTick(()=>{
        setTimeout(this.searchEvent,500)
      })
    },
    searchEvent() {
      AMap.plugin(["AMap.PlaceSearch",'AMap.AutoComplete'], () => {
        //构造地点查询类

        var placeSearch = new AMap.PlaceSearch({
          pageSize: 30, // 单页显示结果条数
          pageIndex: 1, // 页码
          city: this.city,
          citylimit: false,  //是否强制限制在设置的城市内搜索
          map: this.map, // 展现结果的地图实例
          panel: "panel", // 结果列表将在此容器中进行展示。
          autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        });
        var autoOptions = {
          input: "tipinput",
          city: this.city,
          datatype:'poi'
        };
        var auto = new AMap.AutoComplete(autoOptions);

        placeSearch.on('listElementClick', (event) => {
          console.log("click event", event)
        })
        placeSearch.on( "markerClick",  (e) => {

          let data = {
            address:e.data.address,
            point: {
              lng: e.data.location.lng,
              lat:e.data.location.lat
            },
          }
          this.getClickInfo(data)

        })
        if(this.searchText){
          console.log("searchText",this.searchText)
          placeSearch.search(this.searchText);
        }

        //关键字查询
        auto.on('select',(e)=>{
          placeSearch.search(e.poi.name);
          this.zoomIndex = 18
        })
      });
    },
    clickArrayMarker(marker, e) {
      console.log("clickArrayMarker", marker, e)
      let data = {
        point: {
          lng: marker.position[0],
          lat: marker.position[1]
        },
        id: marker.id
      }
      this.getClickInfo(data)
    },
    clickMap(e) {
      console.log('click map :', e);
      let data = {
        point: {
          lng: e.lnglat.lng,
          lat: e.lnglat.lat
        },
      }
      this.getClickInfo(data)
    },
    getClickInfo(data) {
      var convertor = new BMapGL.Convertor();
      var pointArr = [];
      console.log(new AMap.Marker())
      AMap.plugin('AMap.Geocoder', () => {
        var geocoder = new AMap.Geocoder({
          radius: 1000 //范围，默认：500
        });
        geocoder.getAddress([data.point.lng, data.point.lat], (status, result) => {
          if (status === 'complete' && result.regeocode) {
            var address = result.regeocode.formattedAddress;
            console.log('根据经纬度查询地址--', address)
            pointArr.push(new BMapGL.Point(data.point.lng, data.point.lat));
            convertor.translate(pointArr, 3, 5, (data) => {
              console.log("转换后的数据", data)
              this.center.lng = data.points[0].lng
              this.center.lat = data.points[0].lat
              let returnDate = {
                address: address,
                point: {
                  lng: data.points[0].lng,
                  lat: data.points[0].lat
                }
              }
              this.$emit('getClickInfo', returnDate)
            })
          } else {
            log.error('根据经纬度查询地址失败')
          }
        });
      })


    },
  }
}
</script>

<template>
  <div class="map-content">
    <div class="search-box">
      <a-input-group compact>
        <a-select size="large" style="width: 80px" v-model:value="city" @change="searchEvent">
          <a-select-option value="全国">{{ $t('keyquanguo') }}</a-select-option>
          <a-select-option value="北京">{{ $t('keybeijing') }}</a-select-option>
          <a-select-option value="上海">{{ $t('keyshanghai') }}</a-select-option>
          <a-select-option value="深圳">{{ $t('keyshenzhen') }}</a-select-option>
          <a-select-option value="广州">{{ $t('keyguangzhou') }}</a-select-option>
          <a-select-option value="香港">{{ $t('keyxianggang') }}</a-select-option>
        </a-select>
        <a-input id="tipinput" :placeholder="$t('keyqingshuruguanjianzi')" size="large" style="width: 300px;" v-model="searchText"
        ></a-input>
      </a-input-group>
    </div>
    <div id="panel"></div>
    <el-amap vid="amapDemo" ref="map" @click="clickMap" @init="init" class="amap-view" :zoom="zoomIndex"
             :center="center.length == 0?undefined:center">
      <el-amap-marker v-for="(marker, index) in markers" :key="index" :topWhenClick="true" :position="marker.position"
                      @click="(e) => {clickArrayMarker(marker, e)}"></el-amap-marker>

    </el-amap>
  </div>
</template>

<style scoped lang="less">
.amap-view {
  height: calc(100vh - 180px);
}

.map-content {
  position: relative;

  .search-box {
    background: #fff;
    position: absolute;
    z-index: 999;
    left: 10px;
    top: 10px;
  }

  #panel {
    position: absolute;
    background-color: white;
    max-height: 90%;
    overflow-y: auto;
    top: 10px;
    right: 10px;
    z-index: 999;
    width: 280px;
  }
}

</style>